import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { VehicleStatusDataInterface } from '../../models/dashboard/dashboard/vehicle-status';

interface IInitialState {
  driverTypeDistribution?: VehicleStatusDataInterface[];
}

const initialState: IInitialState = {
  driverTypeDistribution: undefined
};

const driverTypeDistributionSlice = createSlice({
  name: 'driverTypeDistributionSlice',
  initialState,
  reducers: {
    setDriverTypeDistribution(state, action: PayloadAction<VehicleStatusDataInterface[]>) {
      state.driverTypeDistribution = action.payload;
    },
  },
});

export const driverTypeDistributionActions = driverTypeDistributionSlice.actions;
export default driverTypeDistributionSlice.reducer;
